import { Team } from './types'
export const initialTeamState: Team = {
  name: '',
  members: [],
}
